import { Box, Stack, Text } from '@mantine/core';

import { NavLink } from 'react-router-dom';

const IdCell = ({ cell }) => {
    const { column, row } = cell;
    const rowData = row.original;
    return (
        <Box
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
            }}>
            <Text>{rowData.eventId}</Text>
        </Box>
    );
};

const IdColumn = () => ({
    accessorKey: 'id',
    header: 'Id',
    size: 1,
    Cell: ({ cell }) => <IdCell cell={cell} />,
});
export default IdColumn;
